
import { NgModule } from '@angular/core';
// import { RouterModule } from '@angular/router';

import { FuseSidebarModule } from './../../../../@fuse/components/sidebar/sidebar.module';
import { FuseSharedModule } from './../../../../@fuse/shared.module';
import { PlatformBreadcrumbSharedModule } from '@ecap3/app-platform-breadcrumb-shared-module';
import { ChatPanelModule } from './../../components/chat-panel/chat-panel.module';
import { ContentModule } from './../../components/content/content.module';
import { FooterModule } from './../../components/footer/footer.module';
import { NavbarModule } from './../../components/navbar/navbar.module';
import { QuickPanelModule } from './../../components/quick-panel/quick-panel.module';
import { QuickPanelComponent } from './../../components/quick-panel/quick-panel.component';
import { ToolbarModule } from './../../components/toolbar/toolbar.module';
import { ToolbarComponent } from './../../components/toolbar/toolbar.component';

import { VerticalLayout1Component } from './../../vertical/layout-1/layout-1.component';
import { PlatformBreadCrumbModule } from '@ecap3/app-platform-breadcrumb';
import {FuseChatPanelComponentDynamic} from '../../components/chat-panel-dynamic/chat-panel-dynamic.component';
import { SidePanelModule } from '../../components/side-panel-dynamic/side-panel.module';
import { DeviceZoomControlComponent } from '../../components/device-zoom-control/device-zoom-control.component';
@NgModule({
    declarations: [
        VerticalLayout1Component,
        FuseChatPanelComponentDynamic,
        DeviceZoomControlComponent
    ],
    imports: [
        // RouterModule,
        FuseSharedModule,
        FuseSidebarModule,
        ChatPanelModule,
        ContentModule,
        FooterModule,
        NavbarModule,
        QuickPanelModule,
        SidePanelModule,
        ToolbarModule,
        PlatformBreadCrumbModule,
        PlatformBreadcrumbSharedModule
    ],
    exports: [
        VerticalLayout1Component
    ]
})
export class VerticalLayout1Module {
}
